import { ArrowButton } from '../../../../ui';
import React from 'react';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import {
	Dialog,
	DialogHeader,
	DialogMain,
} from '../../../shared/components/dialog';
import { DialogActions } from '../../../shared/components/dialog/DialogActions';

interface ISessionExpiredErrorDialogProps {
	onClose: () => void;
}

export const SessionExpiredErrorDialog = ({
	onClose,
}: ISessionExpiredErrorDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog
			ariaLabel={t('parking_payment_session_error_title')}
			onClose={onClose}
		>
			<DialogHeader>
				<h3>{t('parking_payment_session_error_title')}</h3>
			</DialogHeader>
			<DialogMain>
				<p>{t('parking_payment_session_error_body')}</p>
				<DialogActions justifyContent="flex-end">
					<ArrowButton onClick={onClose}>
						{t('parking_payment_session_error_retry')}
					</ArrowButton>
				</DialogActions>
			</DialogMain>
		</Dialog>
	);
};
